//-- Copyright (c) 2021 TMT Insights Group, LLC
import { Link } from 'react-router-dom';
import { Button, Grid } from '@mui/material';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { clearFilters } from '@/redux/slices/dataTableSlice';
import { selectDataTableAppliedSearchName, selectTableTitle } from '@/redux/selectors/dataTableSelectors';
import { Breadcrumbs, Title, TitleBar } from '@/components/_common';
import { PolarisIcon } from '@/exports/columnCommonComponents';

const AvailsScheduleTitleBar = () => {
  const dispatch = useAppDispatch();
  const appliedSearchName = useAppSelector(selectDataTableAppliedSearchName);
  const pageTitle = useAppSelector(selectTableTitle) || 'Avails Schedule';

  const onBreadcrumbClick = () => {
    dispatch(clearFilters());
  };

  return (
    <TitleBar>
      <Grid container justifyContent="space-between" alignItems="center">
        {!appliedSearchName ? (
          <Title>{pageTitle}</Title>
        ) : (
          <Breadcrumbs aria-label="breadcrumb">
            <Link to="/focus/schedule" onClick={onBreadcrumbClick}>
              {pageTitle}
            </Link>
            <span>&ldquo;{appliedSearchName}&ldquo;</span>
          </Breadcrumbs>
        )}
        <Button variant="contained" color="primary" component={Link} to="/focus/schedule/new" startIcon={<PolarisIcon icon="add" height={16} />}>
          New Schedule
        </Button>
      </Grid>
    </TitleBar>
  );
};

export default AvailsScheduleTitleBar;
